<template>
  <span class="ksk-ring" :style="{ width: size + 'px', height: size + 'px' }">
    <svg :viewBox="`0 0 ${size} ${size}`" aria-hidden="true">
      <circle
        class="ksk-ring__track"
        :cx="size / 2"
        :cy="size / 2"
        :r="radius"
        :stroke-width="stroke"
      />
      <circle
        class="ksk-ring__bar"
        :cx="size / 2"
        :cy="size / 2"
        :r="radius"
        :stroke-width="stroke"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="circumference * (1 - progress)"
      />
    </svg>
    <span class="ksk-ring__value">{{ value }}</span>
  </span>
</template>

<script>
// KSK014 — display-only countdown ring. The owner keeps its own timer and
// passes the remaining seconds in; the ring treats the largest value it has
// seen as 100%, so it works for the 50/60/70s gateway timers alike.
export default {
  name: "KskCountdownRing",
  props: {
    seconds: { type: [Number, String], default: 0 },
    size: { type: Number, default: 72 },
    stroke: { type: Number, default: 6 },
  },
  data() {
    return { max: Number(this.seconds) || 0 };
  },
  computed: {
    value() {
      return Math.max(0, Number(this.seconds) || 0);
    },
    radius() {
      return (this.size - this.stroke) / 2;
    },
    circumference() {
      return 2 * Math.PI * this.radius;
    },
    progress() {
      return this.max > 0 ? Math.min(1, this.value / this.max) : 0;
    },
  },
  watch: {
    seconds(value) {
      if (Number(value) > this.max) this.max = Number(value);
    },
  },
};
</script>

<style scoped>
.ksk-ring {
  position: relative;
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
}
.ksk-ring svg {
  position: absolute;
  inset: 0;
  transform: rotate(-90deg);
}
.ksk-ring__track {
  fill: none;
  stroke: var(--ksk-border);
}
.ksk-ring__bar {
  fill: none;
  stroke: var(--ksk-error);
  stroke-linecap: round;
  transition: stroke-dashoffset 0.9s linear;
}
.ksk-ring__value {
  position: relative;
  font-family: var(--ksk-font);
  font-size: var(--ksk-label-size);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--ksk-text);
}
</style>
